import { ContactGroupUsers } from './ContactGroupUsers';
import { DeleteButton } from '../../../components/DeleteButton';
import { EditButton } from '../../../components/EditButton';

export const ContactGroupEntry = ({ contactGroup, handleDelete, handleEdit }) => {
       
    return (
        <tr>
            <td className="align-left">
                {contactGroup.name}
            </td>
            <td className="align-left">
                {contactGroup.description}
            </td>
            <td className="align-left">
                {contactGroup.extension}
            </td>
            <td className="align-left">
                <ContactGroupUsers users={contactGroup.users}/>
            </td>            
            <td className="align-left">
                <DeleteButton className="float-right mr-1" tooltip="Delete" onClick={() => handleDelete(contactGroup)} />
                <EditButton className="float-right mr-1" tooltip="Edit" onClick={() => handleEdit(contactGroup)} />                
            </td>
        </tr>
    )
}